import React from 'react'
import { Divider } from '@retailer-platform/shared-components/src/tds'
import styled from '@emotion/styled'
import { spacing, Text } from '@retailer-platform/shared-components'
import { SwitchBase } from '@instacart/ids-customers'
import {
  Input,
  PropertyTitle,
  SectionHeader,
} from '../../shared-styled-components/SharedStyledComponents'
import { useDomainMessages } from '../../../utils/domain/intl'
import PublishDataGrid from './publication-data-table-components/PublishDataGrid'
import { type FormProps } from './StepAttributeForm'

const Container = styled.div({
  padding: `${spacing.X16} ${spacing.X20}`,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.X16,
})

const Row = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: spacing.X16,
  alignItems: 'center',
})

const FlexOne = styled.div({
  flex: 1,
})

const PublishForm: React.FC<FormProps> = ({ attributes, mode, onChange, version }) => {
  const i18n = useDomainMessages({
    productIdField:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.publishForm.productIdField.label',
    retailerIdField:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.publishForm.retailerIdField.label',
    localeField:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.publishForm.localeField.label',
    headerAttributes:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.publishForm.header.attributes',
    attributesDescription:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.publishForm.attributes.description',
    publicationDetailsDescription:
      'catalogAdminDomain.attributeManagement.stepAttributeForms.publishForm.publicationDetails.description',
  })
  return (
    <>
      <SectionHeader>Publication Details</SectionHeader>
      <Container>
        <Text size="small">{i18n.publicationDetailsDescription}</Text>
        <Row>
          <PropertyTitle>{i18n.productIdField}&nbsp;</PropertyTitle>
          {mode !== 'edit' ? (
            <FlexOne>{attributes.productIdField}</FlexOne>
          ) : (
            <Input
              value={attributes.productIdField}
              onChange={(e: any) => onChange({ ...attributes, productIdField: e.target.value })}
              disabled={mode !== 'edit'}
              error={attributes.productIdField === ''}
            />
          )}
        </Row>
        <Row>
          <PropertyTitle>{i18n.retailerIdField}&nbsp;</PropertyTitle>
          <SwitchBase
            checked={attributes.useRetailerId}
            onChange={(checked: boolean) => onChange({ ...attributes, useRetailerId: checked })}
            description="Use Retailer ID"
            disabled={mode !== 'edit'}
          />
          <Input
            value={attributes.useRetailerId ? attributes.retailerIdField : 'Product Level'}
            onChange={(e: any) => onChange({ ...attributes, retailerIdField: e.target.value })}
            disabled={mode !== 'edit' || !attributes.useRetailerId}
            error={attributes.useRetailerId && attributes.retailerIdField === ''}
          />
          <PropertyTitle>{i18n.localeField}&nbsp;</PropertyTitle>
          <SwitchBase
            checked={attributes.useLocale}
            onChange={(checked: boolean) => onChange({ ...attributes, useLocale: checked })}
            description="Use Locale"
            disabled={mode !== 'edit'}
          />
          <Input
            value={attributes.useLocale ? attributes.localeField : 'Universal'}
            onChange={(e: any) => onChange({ ...attributes, localeField: e.target.value })}
            disabled={mode !== 'edit' || !attributes.useLocale}
            error={attributes.useLocale && attributes.localeField === ''}
          />
        </Row>
        <Divider />
        <SectionHeader>{i18n.headerAttributes}</SectionHeader>
        <Container>
          <Text size="small">{i18n.attributesDescription}</Text>
          <PublishDataGrid
            data={attributes.data}
            onUpdate={data => onChange({ ...attributes, data })}
            disabled={mode !== 'edit'}
          />
        </Container>
      </Container>
    </>
  )
}

export default PublishForm
